import React, { useState } from "react";
import "./Counter.css";
import CountUp from "react-countup";
import ScrollTrigger from 'react-scroll-trigger';

const Counter = () => {
    const [counterOn, setCounter] =useState('false')
  return (
    <div>
      <div className="counter">
        <div className="container">
            <h5>Our Numbers show Our Success</h5>
            <ScrollTrigger onEnter={()=> setCounter(true)} onExit={()=>setCounter(false)}>
            <div className="row">
                <div className="col">
                    <div className="counter-details">
                        {counterOn && <CountUp start={0} end={32000} duration={2} /> }<span className="plus-icon">+</span>
                        <h6>Vendors</h6>
                    </div>
                </div>
                <div className="col">
                <div className="counter-details">
                        {counterOn && <CountUp start={0} end={135000} duration={2} /> }<span className="plus-icon">+</span>
                        <h6>PO</h6>
                    </div>
                </div>
                <div className="col">
                <div className="counter-details">
                        {counterOn && <CountUp start={0} end={160000} duration={2} /> }<span className="plus-icon">+</span>
                        <h6>ASN</h6>
                    </div>
                </div>
                <div className="col">
                <div className="counter-details">
                        {counterOn && <CountUp start={0} end={140000} duration={2} /> }<span className="plus-icon">+</span>
                        <h6>Invoices</h6>
                    </div>
                </div>
                <div className="col">
                <div className="counter-details">
                        {counterOn && <CountUp start={0} end={600000} duration={2} /> }<span className="plus-icon">+</span>
                        <h6>SKUs</h6>
                    </div>
                </div>
            </div>
            </ScrollTrigger>
        </div>
      </div>
    </div>
  );
};

export default Counter;
